import { ComponentButton } from './ComponentButton';
import { ActionButton as ActionButtonType } from '@/schemas/sceneDataSchema';
import { useAction } from '@/hooks/use-action';
import { RouteFn } from '@/hooks/use-flow';
import useToast from '@/hooks/use-toasts';

export const ActionButton = ({ component, route }: { component: ActionButtonType; route: RouteFn }) => {
  const { executeAction, isLoading } = useAction();

  const { getToast } = useToast();
  const successToast = getToast(component.success_toast_id ?? '');
  const errorToast = getToast(component.error_toast_id ?? '');

  const onClick = () => {
    executeAction(component.action, component.arguments ?? {}, route)
      .then(() => {
        if (successToast) {
          successToast.open();
        }
      })
      .catch(() => {
        if (errorToast) {
          errorToast.open();
        }
      });
  };

  return (
    <ComponentButton
      onClick={onClick}
      component={component}
      type='button'
      loading={isLoading}
    />
  );
};
